import api from "@/api/axios.js";

export async function fetchJobs()
{
	const {data} = await api.get("/api/webp/jobs");
	return data.jobs || [];
}

export async function fetchJob(jobId)
{
	const {data} = await api.get(`/api/webp/jobs/${jobId}`);
	return data.job;
}

export async function createJobFromFiles(files, options = {})
{
	const formData = new FormData();
	files.forEach(file =>
	{
		const filename = file?.webkitRelativePath || file?.name || "file";
		formData.append("files", file, filename);
	});

	const name = options.name || options.jobName;
	if (name)
		formData.append("name", name);

	const {data} = await api.post("/api/webp/jobs", formData, {
		headers: {"Content-Type": "multipart/form-data"}
	});

	return data.job;
}

export async function downloadJobArchive(jobId)
{
	const response = await api.get(`/api/webp/jobs/${jobId}/download`, {responseType: "blob"});

	const disposition = response.headers?.["content-disposition"] || "";
	const match = disposition.match(/filename="?([^";]+)"?/i);
	const filename = match ? match[1] : `job-${jobId}.zip`;

	return {data: response.data, filename};
}
